import './index.css';

export default {
  name: 'Amenu',
  props: {
    mode: { type: String, default: () => 'vertical' },
    defaultActive: { type: String, default: () => '/index' },
    defaultOpeneds: { type: Array, default: () => [] },
    uniqueOpened: { type: Boolean, default: () => true },
    router: { type: Boolean, default: () => true },
    reload: { type: Boolean, default: () => false },
    menuTrigger: { type: String, default: () => 'hover' },
    collapse: { type: Boolean, default: () => false },
    backgroundColor: { type: String, default: () => '#001529' },
    textColor: { type: String, default: () => '#afafaf' },
    activeTextColor: { type: String, default: () => '#ffffff' },
    collapseTransition: { type: Boolean, default: () => true },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    theme: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      active: '/index',
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler() {
        this.create();
        this.$nextTick(() => this.relate());
      },
    },
    $route({ path = null }) {
      if (path && (path !== this.active)) this.relate();
    }
  },
  methods: {
    create() {
      const list = this.options || this.option || this.config || this.items || this.data || [];
      if (list && (list.length > 0)) {
        const data = [];
        list.forEach((a, b) => data[b] = this.format(a, b));
        return data;
      }
    },
    format({ type = 1, ...r }, key, listCode = 0, menuCode = 1, linkCode = 2) {
      const node = r.children || r.child || r.node || r.data || [];
      const text = r.title || r.label || r.text || r.name || '';
      const icon = r.vueIcon || r.image || r.icon || r.img || '';
      const path = r.index || r.route || r.path;
      const color = this.active == path ? this.activeTextColor : this.textColor;
      if (type == listCode) {
        return (
          <el-submenu popper-class="a-menu-popup" key={key} index={path} {...{ props: r }}>
            <template slot="title">
              {icon != '' ? <i class={`${icon} a-menu-item-icon`} style={{ color }} /> : ''}
              <span slot="title" class="a-menu-item-text" style={{ color }}>{text}</span>
            </template>
            {node && node.length > 0 && node.map((a, b) => this.format(a, b))}
          </el-submenu>
        );
      } else {
        if (type == menuCode || type == linkCode) {
          return (
            <el-menu-item key={key} index={path} {...{ props: r }}>
              {icon != '' ? <i class={`${icon} a-menu-item-icon`} style={{ color }} /> : ''}
              <span slot="title" class="a-menu-item-text" style={{ color }}>{text}</span>
            </el-menu-item>
          );
        }
      }
    },
    relate() {
      const { page } = this.$route.query;
      if (page && page != '') {
        this.active = page;
      } else {
        const { meta } = this.$route;
        if (meta && meta.page) {
          this.active = meta.page;
        } else {
          this.active = location.pathname;
        }
      }
    },
    open(key, keyPath) {
      this.$emit('open', { key, keyPath });
    },
    close(key, keyPath) {
      this.$emit('close', { key, keyPath });
    },
    select(key, keyPath) {
      if (!this.reload && this.active == key) return false;
      this.active = key;
      this.$nextTick(() => this.$emit('select', { key, keyPath }));
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <div class={['a-menu', this.mode]} style={{ backgroundColor: this.backgroundColor }}>
        <el-menu
          mode={this.mode}
          default-active={this.active}
          default-openeds={this.defaultOpeneds}
          unique-opened={this.uniqueOpened}
          router={this.router}
          menu-trigger={this.menuTrigger}
          collapse={this.collapse}
          collapse-transition={this.collapseTransition}
          on-open={this.open}
          on-close={this.close}
          on-select={this.select}
          {...{ attrs }}
        >
          {this.create()}
        </el-menu>
      </div>
    );
  }
}